export default __webpack_public_path__ + "static/media/nunzio-guerrera-LA8kstntJhI-unsplash.8e10b0a6.jpg";